import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { solutions } from "../mock";

function Card({ s }) {
  return (
    <>
      <div className="relative h-64 overflow-hidden bg-[var(--ink-2)]">
        <img
          src={s.image}
          alt={s.title}
          className="w-full h-full object-contain p-6 transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-5 left-5 font-serif-display text-sm text-[var(--gold)] tracking-widest">
          {s.tag}
        </span>
      </div>
      <div className="p-8">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-serif-display text-2xl font-semibold">{s.title}</h3>
          <ArrowUpRight
            size={22}
            className="text-[var(--muted)] group-hover:text-[var(--gold)] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all shrink-0"
          />
        </div>
        <p className="mt-3 text-[var(--muted)] leading-relaxed">{s.body}</p>
        {s.link && (
          <span className="inline-flex items-center gap-1 mt-4 text-sm font-semibold text-[var(--gold)]">
            See how VPV works <ArrowUpRight size={15} />
          </span>
        )}
      </div>
    </>
  );
}

export default function Solutions() {
  return (
    <section id="solutions" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <p className="eyebrow">Proven Solutions For Exhibition Success</p>
          <h2 className="mt-5 font-serif-display text-4xl sm:text-6xl font-semibold leading-[1.02]">
            Everything you need to <span className="text-gradient-gold italic">win the floor</span>
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
          {solutions.map((s, i) =>
            s.link ? (
              <Link
                key={s.title}
                to={s.link}
                className="card-lux rounded-3xl overflow-hidden reveal group block"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <Card s={s} />
              </Link>
            ) : (
              <article
                key={s.title}
                className="card-lux rounded-3xl overflow-hidden reveal group"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <Card s={s} />
              </article>
            )
          )}
        </div>
      </div>
    </section>
  );
}
